import { graphql } from "~/lib/graphql";

export const LpCardBlockFragment = graphql(`
  fragment LpCardBlockFragment on LpCardBlockRecord {
    __typename
    id
    gridColumns
    card {
      id
      title
      text(markdown: false)
      slug
      externalUrl
      ctaLabel
      page {
        ... on LandingDetailPageRecord {
          __typename
          id
          slug(fallbackLocales: en)
          title
        }
        ... on LandingFrontPageRecord {
          __typename
          id
          name
          slug
          title
        }
      }
      image {
        id
        title
        author
        copyright
        blurUpThumb
        height
        width
        url
        alt
        focalPoint {
          x
          y
        }
      }
    }
  }
`);
